export const BeachwatchPartnersLatestReportsLinks = [
    {
        partner: "Ballina Shire Council",
        latestReport: "https://www.environment.nsw.gov.au/publications/state-beaches-2023-24-north-coast-region",
    },
    {
        partner: "Beachwatch - Sydney Coast",
        latestReport: "https://www.environment.nsw.gov.au/publications/state-beaches-2023-24-sydney-region",
    },
    {
        partner: "Bellingen Shire Council",
        latestReport: "https://www.environment.nsw.gov.au/publications/state-beaches-2023-24-mid-north-coast-region ",
    },
    {
        partner: "Blue Mountains City Council",
        latestReport: "https://www.environment.nsw.gov.au/publications/state-beaches-2023-24-sydney-region",
    },
    {
        partner: "Central Coast Council",
        latestReport: "https://www.environment.nsw.gov.au/publications/state-beaches-2023-24-central-coast-region",
    },
    {
        partner: "Department of Planning and Environment – Penrith Beach",
        latestReport: "https://www.environment.nsw.gov.au/publications/state-beaches-2023-24-sydney-region",
    },
    {
        partner: "Eurobodalla Shire Council",
        latestReport: "https://www.environment.nsw.gov.au/publications/state-beaches-2023-24-south-coast-region",
    },
    {
        partner: "Hunter Water - Hunter beaches",
        latestReport: "https://www.environment.nsw.gov.au/publications/state-beaches-2023-24-hunter-region",
    },
    {
        partner: "Kiama Municipal Council",
        latestReport: "https://www.environment.nsw.gov.au/publications/state-beaches-2023-24-illawarra-region",
    },
    {
        partner: "Richmond Valley Council",
        latestReport: "https://www.environment.nsw.gov.au/publications/state-beaches-2023-24-north-coast-region",
    },
    {
        partner: "Shoalhaven City Council",
        latestReport: "https://www.environment.nsw.gov.au/publications/state-beaches-2023-24-south-coast-region",
    },
    {
        partner: "Sydney Water - Illawarra beaches",
        latestReport: "https://www.environment.nsw.gov.au/publications/state-beaches-2023-24-illawarra-region",
    },
    {
        partner: "Wollongong City Council",
        latestReport: "https://www.environment.nsw.gov.au/publications/state-beaches-2023-24-illawarra-region"
    }
];
